<h1 mat-dialog-title>Attach a file <span tabindex="0" role="button" (click)="onNoClick()" (keyup.enter)="onNoClick()"
    class="close">Close X</span></h1>

<form [formGroup]="fileForm">
    <mat-dialog-content aria-live="polite">
        <mat-card appearance="outlined" class="af-mat-card mat-elevation-z">
            <mat-card-header>
                <div mat-card-avatar class="example-header-image">
                    <img alt="information" src="assets/bofa_icon_info.svg" class="img-size" role="img">
                </div>
                <mat-card-title class="zoom-text-dialog">Allowed file formats</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>{{this.fileFormat}}</p>                
            </mat-card-content>
        </mat-card>

        <p *ngIf="descOfFileName.value == '4' || descOfFileName.value == '35'" class="bofa--heading is-9 global-red" aria-live="polite">
            If you are attaching Court Documents or Credit Documents, please ensure you have answered the questions on
            the Criminal History page accurately and have provided all relevant Offense/Regulatory Action Details.
        </p>

        <div *ngIf="!ousAttachments" class="padd-15">
            <mat-form-field class="max-zoom-dialog" hideRequiredMarker>
                <mat-label><abbr title="required">* </abbr>File description</mat-label>
                <mat-select formControlName="descOfFileName" required>
                    <mat-option>Select</mat-option>
                    <mat-option *ngFor="let descOfFileName of fileDescriptionLookup | keyvalue  : valueAscOrder"
                        [value]="descOfFileName.key">
                        {{descOfFileName.value}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="fileForm.controls.descOfFileName.hasError('required') ">Please select File description
                </mat-error>
            </mat-form-field>
        </div>

        <div class="padd-15">
            <app-file-upload [descOfFileName]="descOfFileName" [ousAttachments]="ousAttachments"
                [ousAttachmentId]="ousAttachmentId" [verifyId]="verifyId" [fileFormat]="fileFormat" [ousAttachmentDesc]="ousAttachmentDesc"></app-file-upload>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <div class="is-taller">
            <div class="level">
                <div class="level-item">
                    <button class="bofa--button secondary outlined" type="button" (click)="onNoClick()">Cancel</button>
                </div>

                <div class="level-item">
                    <button class="bofa--button secondary" type="button" [disabled]="fileForm.invalid || inProgress"
                        (click)="uploadClick()">Upload</button>
                </div>
            </div>
        </div>
    </mat-dialog-actions>
</form>